"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.LogoFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M7 3H3V7H7V3Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M7 7H3V11H7V7Z", fill: colors[1] }),
            react_1.default.createElement("path", { d: "M3 11H7L3 15V11Z", fill: colors[2] }),
            react_1.default.createElement("path", { d: "M7 7H11L7 11V7Z", fill: colors[2] }),
            react_1.default.createElement("path", { d: "M11 3H15L11 7V3Z", fill: colors[0] }),
            react_1.default.createElement("path", { d: "M11 7H7L11 3V7Z", fill: colors[1] }));
    },
    name: 'logo_filled',
    defaultColors: ['#1274FE', '#539AFF', '#7EB3FF'],
    colorful: true,
    allPathData: ['M7 3H3V7H7V3Z', 'M7 7H3V11H7V7Z', 'M3 11H7L3 15V11Z', 'M7 7H11L7 11V7Z', 'M11 3H15L11 7V3Z', 'M11 7H7L11 3V7Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
